<template>
    <div ref="vimeoContainer" class="vimeo-wrapper"></div>
  </template>
  
  <script>
  import Player from '@vimeo/player'
  
  function setCookie(name, value, minutes) {
    var expires;
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  export default {
    name: 'VimeoPlayer',
    
    props: {
      videoId: {
        type: [String, Number],
        required: true
      },
      options: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        player: null,
        rafId: null,
        status: 'paused'
      }
    },
    mounted() {
      const config = Object.assign({}, this.options, {
        id: this.videoId
      });
  
      this.player = new Player(this.$refs.vimeoContainer, config)
  
      this.player.ready().then(() => {
        this.$emit('ready', this.player);
        this.startWatchTime();
      });

      this.player.on('cuepoint', data => {
        this.$emit('cuepoint', data)
      });

      window.addEventListener('resize', this.setHeight)
      this.setHeight()


    },
    beforeDestroy() {

      window.removeEventListener('resize', this.setHeight)

      if (this.rafId) {
        cancelAnimationFrame(this.rafId)
      }
      
      if (this.player) {
        this.player.off('cuepoint') // nettoie listeners
        this.player.unload().catch(() => {}) // évite audio qui reste
        return this.player.destroy().catch(console.warn)
      }
    },
    methods: {
      startWatchTime() {
        const loop = async () => {
          if (!this.player) return
          
          const time = await this.player.getCurrentTime();
          this.$emit('timeupdate', time) ;

          this.rafId = requestAnimationFrame(loop)
        }

        this.rafId = requestAnimationFrame(loop)
      },

      play() {
        this.status = 'playing';
        return this.player && this.player.play()
      },
      pause() {
        this.status = 'paused';
        
        cancelAnimationFrame(this.rafId);

        return this.player && this.player.pause()
      },
      getPlayer() {
        return this.player
      },
      getStatus() {
        return this.status;
      },
      setHeight() {
        const container = this.$refs.vimeoContainer
        if (container) {
          const width = container.clientWidth
          container.style.height = `${width * 9 / 16}px`
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .vimeo-wrapper {
    width: 100%;
    aspect-ratio: 16 / 9;
  }
  </style>
  